module.exports = __webpack_public_path__ + "img/194-malta.75f348c6.svg";